import React, { useEffect, useState, useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { fetchUserById } from '../../actions/request/UserRequest';
import { useNavigate, useParams } from 'react-router-dom';
import { currentDate, emptyImage, logoApplication, profilePictureDefault } from '../../utils/dataApi/dataFormApi';
import Select from "react-select";
import moment from 'moment';
import { MdCarRental, MdCardTravel, MdCategory, MdDateRange, MdDirectionsCar, MdHome, MdHomeFilled, MdLocationOn, MdMail, MdOutlineAirlineSeatReclineNormal, MdOutlineLocationOn, MdPerson, MdTimer } from 'react-icons/md';
import { fetchPropertysAllByOwnerId, fetchPropertysAllResearch, fetchPropertysAllResearchAvailable } from '../../actions/request/PropertyRequest';
import { Button, Col, Container, Form, Pagination, Row, Card, Badge, Modal, Spinner, Offcanvas } from 'react-bootstrap';
import { ROUTES } from '../../config/routingUrl';
import { fetchVehiclesAllByOwnerIdAvailable, fetchVehiclesAllResearch, fetchVehiclesAllResearchAvailable } from '../../actions/request/VehicleRequest';
import { FaArrowAltCircleRight, FaHome, FaSearch } from 'react-icons/fa';
import { FETCH_PROPERTY_SUCCESS, FETCH_VEHICLE_SUCCESS } from '../../app/actions/actions';
import { RiFilter3Line } from 'react-icons/ri';
import { dureeDeVie, setWithExpiration } from '../../utils/storage/localvalueFuction';
import { localStorageKeys } from '../../utils/storage/localvalue';
import axios from 'axios';
import { baseurl } from '../../utils/url/baseurl';
import { ContainerFilter } from '../../components/web/cars/CarListFilterList';
import { fetchVehicleBrandsAll } from '../../actions/request/VehicleBrandRequest';
import { fetchVehicleModelsAll } from '../../actions/request/VehicleModelRequest';
import { fetchengineTypesAll } from '../../actions/request/EngineTypeRequest';
import { fetchInteriorTypesAll } from '../../actions/request/InteriorTypeRequest';
import { FaCar, FaCarRear, FaChargingStation } from 'react-icons/fa6';
import DatePicker from 'react-datepicker';
import { Range } from 'react-range';
import { IoSpeedometerOutline } from 'react-icons/io5';
import { TbManualGearbox } from 'react-icons/tb';

const CarUserPage = () => {
    const paramUser = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.users.user);
    const loadingVehicles = useSelector((state) => state.vehicles.loadingVehicles);
    const loadingPropertys = useSelector((state) => state.propertys.loadingPropertys);
    const vehicles = useSelector((state) => state.vehicles.vehiclesAvailable);
    const propertys = useSelector((state) => state.propertys.propertysAvailable);
    const vehiclebrandList = useSelector((state) => state.vehiclebrands.vehiclebrands);
    const interiorTypes = useSelector((state) => state.interiorTypes.interiorTypes);
    const engineTypes = useSelector((state) => state.engineTypes.engineTypes);
    const vehiclemodels = useSelector((state) => state.vehiclemodels.vehiclemodels);
    const [availableStartDate, setAvailableStartDate] = useState('');
    const [availableStartTime, setAvailableStartTime] = useState({ value: '10:00', label: '10:00' });
    const [availableEndDate, setAvailableEndDate] = useState('');
    const [availableEndTime, setAvailableEndTime] = useState({ value: '10:00', label: '10:00' });
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(12);
    const [filterType, setFilterType] = useState("Vehicle");



    // priw
    const [minPrice, setMinPrice] = useState(0);
    const [maxPrice, setMaxPrice] = useState(0);
    // année de construction
    const [minYearBuild, setminYearBuild] = useState(1900);
    const [maxYearBuild, setmaxYearBuild] = useState(0);
    // nombre de passagers
    const [minPassenger, setminPassenger] = useState(1);
    const [maxPassenger, setmaxPassenger] = useState(50);
    // kilometrage
    const [minMileage, setminMileage] = useState(1)
    const [maxMileage, setmaxMileage] = useState(1000000)
    // Categorie
    const [interiorType, setinteriorType] = useState("");
    // moteur
    const [engineType, setengineType] = useState("");
    // marque
    const [vehiclebrand, setvehiclebrand] = useState('');
    // option des propriété et des véhicule en question
    const [optionsItem, setoptionsItem] = useState()
    // Model
    const [model, setmodel] = useState(null)

    const [priceRange, setPriceRange] = useState([minPrice || 1, maxPrice || 1000000]);
    const [passengerRange, setPassengerRange] = useState([minPassenger || 1, maxPassenger || 50]);
    const [mileageRange, setMileageRange] = useState([minMileage || 1, maxMileage || 1000000]);
    const [yearRange, setYearRange] = useState([minYearBuild || 1900, maxYearBuild || new Date().getFullYear()]);

    const [filteredVehicles, setFilteredVehicles] = useState([]);
    const [filteredProperties, setFilteredProperties] = useState([]);


    // Création des options d'heures avec intervalles de 30 minutes
    const hourOptions = Array.from({ length: 24 }, (_, i) => {
        const hour = i.toString().padStart(2, '0');
        return [
            { value: `${hour}:00`, label: `${hour}:00` },
            { value: `${hour}:30`, label: `${hour}:30` }
        ];
    }).flat();




    const vehiclebrandOptions = vehiclebrandList && vehiclebrandList.length > 0 ? vehiclebrandList.map((vehhiclebrand) => ({
        label: vehhiclebrand.name,
        value: vehhiclebrand.name
    })) : []

    const enginetypeOptions = engineTypes && engineTypes.length > 0 ? engineTypes.map((engine) => ({
        label: engine?.name,
        value: engine?._id
    })) : []

    const interiortypeOptions = interiorTypes && interiorTypes.length > 0 ? interiorTypes.map((interiortype) => ({
        label: interiortype?.name,
        value: interiortype?._id
    })) : []

    const vehiclemodelsOptions = vehiclemodels && vehiclemodels.length > 0 ? vehiclemodels.map((interiortype) => ({
        label: interiortype?.name,
        value: interiortype?._id
    })) : []

    const minReturnDate = availableStartDate
        ? new Date(availableStartDate.getTime() + 1 * 24 * 60 * 60 * 1000)
        : null;


    useEffect(() => {
        setminMileage(1);
        setMinPrice(1);
        setMaxPrice(1000000)
        setminYearBuild(1900);
        setmaxYearBuild(new Date().getFullYear())
        dispatch(fetchUserById(paramUser?.id));
        dispatch(fetchVehiclesAllResearchAvailable(currentDate, currentDate, paramUser?.id));
        dispatch(fetchPropertysAllResearchAvailable(currentDate, currentDate, paramUser?.id));
        dispatch(fetchVehicleBrandsAll("available"));
        dispatch(fetchVehicleModelsAll("available"));
        dispatch(fetchengineTypesAll());
        dispatch(fetchInteriorTypesAll());

    }, [dispatch]);

    // useEffect(() => {
    //     // Mettre à jour le maxPrice après le chargement des véhicules
    //     if (vehicles.length > 0) {
    //         setMaxPrice(Math.max(...vehicles.map(v => v.basePricePerDay), 0));
    //     }
    // }, [vehicles]);

    useEffect(() => {
        // Filtrage basé sur le prix
        const vehiclesFiltered = vehicles || []/*.sort((a, b) => b.basePricePerDay - a.basePricePerDay) */
        // .filter((vehicle) => {
        //     const price = vehicle.basePricePerDay || 0;
        //     return price >= minPrice && price <= maxPrice;
        // });

        const propertiesFiltered = propertys || []/*.sort((a, b) => b.basePricePerDay - a.basePricePerDay) */
        // .filter((property) => {
        //     const price = property.price || 0; // Assurez-vous que `price` est défini
        //     return price >= minPrice && price <= maxPrice;
        // });

        setFilteredVehicles(vehiclesFiltered);
        setFilteredProperties(propertiesFiltered);
    }, [vehicles, propertys, minPrice, maxPrice]);



    const currentItems = filterType === "Vehicle"
        ? filteredVehicles.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
        : filteredProperties.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const combineDateAndTime = (date, time) => {
        return moment(`${date}T${time.value}:00.000+00:00`).toISOString();
    };

    const handleSearch = () => {
        setShowOffCanvas(false);
        setCurrentPage(1);


        // Combiner les dates et heures
        const startDateTime = combineDateAndTime(availableStartDate, availableStartTime);
        const endDateTime = combineDateAndTime(availableEndDate, availableEndTime);

        // Envoyer les dates combinées avec la requête de recherche
        // dispatch(fetchPropertysAllResearch(startDateTime, endDateTime, paramUser?.id));
        // dispatch(fetchVehiclesAllResearch(startDateTime, endDateTime, paramUser?.id));
        dispatch(fetchPropertysAllResearchAvailable(startDateTime, endDateTime, paramUser?.id, "", formData.lat, formData.lng, minPrice, maxPrice, "", "", "", optionsItem));
        dispatch(fetchVehiclesAllResearchAvailable(startDateTime, endDateTime, paramUser?.id, "", model?.value, vehiclebrand?.value, minPassenger, maxPassenger, minMileage, maxMileage, minPrice, maxPrice, formData.lat, formData.lng, optionsItem, interiorType?.Value, engineType?.value));


        const filteredVehicles = vehicles.filter((vehicle) => {
            const price = vehicle.basePricePerDay || 0;
            return price >= minPrice && price <= maxPrice;

        });

        const filteredProperties = propertys.filter((property) => {
            const price = property.price || 0; // Assurez-vous que `price` est défini
            return price >= minPrice && price <= maxPrice;
        });


        // Mettre à jour les véhicules et propriétés filtrés dans l'état local
        setFilteredVehicles(filteredVehicles);
        setFilteredProperties(filteredProperties);
        // Fermer Offcanvas après un léger délai pour éviter de perturber la saisie
        setTimeout(() => {
            setShowOffCanvas(false);
        }, 300);
    };

    // Empêcher la sélection de dates passées
    const today = new Date().toISOString().split('T')[0];

    const [formData, setFormData] = useState({
        agenceDepart: '',
        lat: '',
        lng: ''
    });

    const [pickupLocation, setPickupLocation] = useState('');
    const [pickupSuggestions, setPickupSuggestions] = useState([]);

    // Obtenir les suggestions de lieu de départ
    const getPlacesByCountryStartLocation = async (query) => {
        try {
            const response = await axios.get(`${baseurl.url}/api/v1/places`, {
                params: { query: query },
            });
            const places = response.data.results;
            return places.map(place => place);
        } catch (error) {
            console.error("Erreur lors de la récupération des lieux : ", error);
        }
    };

    const handlePickupLocationChange = async (e) => {
        const value = e.target.value;
        setPickupLocation(value);
        setTempLocation(value); // Change la valeur temporairement
        if (value.length == 0 || value == "") {
            setFormData(prevState => ({
                ...prevState,
                agenceDepart: ``,
                lat: '',
                lng: ''
            }));
            setPickupSuggestions([]); // Réinitialiser la liste des suggestions
        }
        else if (value.length > 2) {
            const suggestions = await getPlacesByCountryStartLocation(value);
            setPickupSuggestions(suggestions);
        } else {
            setPickupSuggestions([]); // Réinitialiser la liste des suggestions
        }
    };

    const handlePickupSelection = (suggestion) => {
        setPickupLocation(`${suggestion.name} - ${suggestion.formatted_address}`);
        setFormData(prevState => ({
            ...prevState,
            agenceDepart: `${suggestion.name} - ${suggestion.formatted_address}`,
            lat: suggestion?.geometry?.location?.lat,
            lng: suggestion?.geometry?.location?.lng
        }));

        setWithExpiration(localStorageKeys.agenceDepArt, `${suggestion.name} - ${suggestion.formatted_address}`, dureeDeVie);
        setWithExpiration(localStorageKeys.latSelect, suggestion?.geometry?.location?.lat, dureeDeVie);
        setWithExpiration(localStorageKeys.longSelect, suggestion?.geometry?.location?.lng, dureeDeVie);


        setPickupSuggestions([]);
    };

    const handleCleanSugestions = (event) => {
        // Vérifie si le clic vient bien de l'extérieur des champs input
        if (!event.target.closest('input')) {
            setPickupSuggestions([]);
        }
    };



    const [showOffCanvas, setShowOffCanvas] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

    // Vérification de la largeur de l'écran pour détecter le mode mobile
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 900);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);



    const [tempLocation, setTempLocation] = useState("");



    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setPickupLocation(tempLocation);
        }, 300); // Attends 300ms avant de setter réellement la valeur

        return () => clearTimeout(timeoutId);
    }, [tempLocation]);

    const [showDatePicker, setShowDatePicker] = useState(false);

    // État pour gérer le survol de chaque élément
    const [hoverStates, setHoverStates] = useState({});

    // Fonction pour mettre à jour l'état de survol d'un élément spécifique
    const handleMouseEnter = (id) => {
        setHoverStates((prevState) => ({
            ...prevState,
            [id]: true,
        }));
    };

    const handleMouseLeave = (id) => {
        setHoverStates((prevState) => ({
            ...prevState,
            [id]: false,
        }));
    };




    return (
        <div className="container-fluid" style={{ padding: "150px 0px 30px 0px" }} onClick={handleCleanSugestions}>
            {/*<div className=" mt-5">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card p-3 mb-5 bg-white rounded">
                            <div className="card-header text-center bg-white">
                                <img
                                    src={user?.profilePicture || logoApplication}
                                    alt="Profile"
                                    className="rounded-circle img-fluid"
                                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                />
                                <div>
                                    <h4 className="mt-3">
                                        {user && user.companyName ? (
                                            <p className="mb-1 text-truc">{user.companyName}</p>
                                        ) : (
                                            <p className="mb-1">{user.firstname || ""} {user.lastname || ""}</p>
                                        )}
                                    </h4>
                                </div>

                            </div>
                            <div className="card-body">
                                <ul className="list-group list-group-flush">
                                    {
                                        user.email && (
                                            <li className="list-group-item">
                                                <strong><MdMail /> Email: </strong>{user.email || ""}
                                            </li>
                                        )
                                    }
                                    {
                                        user.createdAt && (
                                            <li className="list-group-item">
                                                <strong>Date d{"'"}inscrit: </strong>
                                                {user && user.createdAt ? moment(user.createdAt).format("DD-MM-YYYY") : ""}
                                            </li>
                                        )
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}


            <div className="container-fluid" style={{ background: "linear-gradient(90deg, #43B613, #1D5008)", }}>
                <div className="container icon-bx-wraper style-3 m-b30 bg-transparent" style={{ border: "2px transparent solid" }}>
                    <div>
                        <img className="photo img-fluid rounded-lg" src={user?.profilePicture || logoApplication || emptyImage} style={{ position: "relative", bottom: -20, minHeight: "100px", maxHeight: "130px", objectFit: 'fill' }} alt="" />
                    </div>
                    <div className="content-box">
                        <h5 className="media-heading m-b10">{user && user.companyName ? (
                            <span className="mb-1 text-truc">{user.companyName}</span>
                        ) : (
                            <span className="mb-1">Agence</span>
                        )}</h5>
                        <ul className="used-car-dl-info" style={{ display: "flex", flexDirection: "column" }}>
                            <li className="text-white"><FaCar /> {vehicles && vehicles.length > 0 && vehicles.filter((item) => item.isVisible == true).length > 0 ? vehicles.filter((item) => item.isVisible == true).length : 0} véhicules disponibles </li>
                            <li className="text-white"><FaHome /> {propertys && propertys.length > 0 && propertys.filter((item) => item.isVisible == true).length > 0 ? propertys.filter((item) => item.isVisible == true).length : 0} véhicules disponibles</li>
                        </ul>
                        {/*<div class="clearfix m-t20">
                            <a href="#" class="btn btn-primary btn-xs m-b5">Send Details on Sms</a>
                            <a href="#" class="btn btn-primary btn-xs m-b5">Locate</a>
                        </div> */}
                    </div>
                </div>
            </div>

            {

                !isMobile && (
                    <div className="container" style={{ width: "100%" }}>
                        <div className="container-barner-home-section-horaire-card">
                            <div className={`${filterType == "Vehicle" ? "container-barner-home-section-horaire-card-button-patrimoine-active" :
                                "container-barner-home-section-horaire-card-button-patrimoine"}`} style={{ cursor: "pointer" }}
                                onClick={() => { setFilterType("Vehicle") }}><FaCarRear size={15} /> <span > Recherchez un véhicule</span> </div>
                            <div className={`${filterType == "Property" ? "container-barner-home-section-horaire-card-button-patrimoine-active" :
                                "container-barner-home-section-horaire-card-button-patrimoine"}`} style={{ cursor: "pointer" }}
                                onClick={() => { setFilterType("Property") }}><MdHome size={15} /> <span > Recherchez une propriété</span> </div>
                        </div>
                        <div className="container-barner-home-section-horaire-card-2 shadow">
                            <div className="row " >
                                <div className="col-md-2" style={{ padding: isMobile ? "10px 0px 0px 0px" : "0px" }}>
                                    <div style={{ color: "#737373" }}>Localisation</div>
                                    <div style={{ color: "#D9D9D9", display: "flex" }} className="position-relative">
                                        <MdLocationOn size={25} />
                                        <span>
                                            <input
                                                className={`bg-transparent  ${isMobile ? "border-0 border-bottom" : "border-0 border-bottom"}`} style={{ color: "#737373", border: "0px 0px 1px 0px #737373 solid", padding: "3px", marginTop: "10px" }}
                                                value={pickupLocation}
                                                onChange={handlePickupLocationChange}
                                                placeholder='Lieu en Algerie'
                                            />
                                            {pickupSuggestions && pickupSuggestions.length > 0 && (
                                                <ul className="rounded p-1 border" style={{ position: 'absolute', zIndex: 1000, backgroundColor: 'white', maxWidth: "400px", listStyleType: 'none', padding: 0, maxHeight: "200px", overflow: "auto" }}>
                                                    {pickupSuggestions.map((suggestion, index) => (
                                                        <li className="border"
                                                            key={index}
                                                            style={{ padding: '5px', cursor: 'pointer', color: "#737373" }}
                                                            onClick={() => handlePickupSelection(suggestion)}
                                                        >
                                                            <MdLocationOn /> {`${suggestion.name} - ${suggestion.formatted_address}`}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </span>
                                    </div>
                                </div>
                                {/* Section Dates */}
                                <div className="col-md-5" style={{ padding: isMobile ? "10px 0px 0px 0px" : "0px" }}>
                                    {/* Étiquette */}
                                    <div style={{ color: "#737373" }}>Dates</div>

                                    {/* Clic pour afficher/masquer le calendrier */}
                                    <div
                                        style={{
                                            color: "#D9D9D9",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => setShowDatePicker(!showDatePicker)}
                                    >
                                        <MdDateRange size={25} style={{ marginTop: "10px" }} />
                                        <div >
                                            <div style={{ marginTop: "10px", display: "flex", flexDirection: isMobile ? "column" : "row", gap: "5px" }}>
                                                {/* Sélecteur de date pour la date de départ */}
                                                <DatePicker
                                                    locale={"fr"}
                                                    selected={availableStartDate}
                                                    onChange={(date) => setAvailableStartDate(date)
                                                    }
                                                    selectsStart
                                                    minDate={today} // Griser les dates passées
                                                    placeholderText="Date de départ"
                                                    dateFormat="dd-MM-yyyy"
                                                    className={`bg-transparent  ${isMobile ? "border-0 border-bottom" : ""}`}
                                                    style={{ height: "30px", width: "40px", borderRadius: "5px", }}
                                                />

                                                {/* Sélecteur de date pour la date de retour */}
                                                <DatePicker
                                                    locale={"fr"}
                                                    selected={availableEndDate}
                                                    onChange={(date) => setAvailableEndDate(date)}
                                                    selectsEnd
                                                    startDate={availableStartDate}
                                                    endDate={availableEndDate}
                                                    minDate={minReturnDate} // Limiter les dates de retour à 2 jours après la date de départ
                                                    placeholderText="Date de retour"
                                                    dateFormat="dd-MM-yyyy"
                                                    className={`bg-transparent  ${isMobile ? "border-0 border-bottom" : ""}`}
                                                    style={{ height: "30px", width: "40px", borderRadius: "5px" }}
                                                    disabled={!availableStartDate} // Désactiver tant que la date de départ n'est pas sélectionnée
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                {/* Section Horaire */}
                                <div className="col-md-3" style={{ padding: isMobile ? "10px 0px 0px 0px" : "0px" }}>

                                    <div
                                        style={{
                                            color: "#D9D9D9",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "20px",
                                        }}
                                    >
                                        <div style={{ gap: "5px", alignItems: "end" }}>
                                            <MdTimer size={25} style={{ marginTop: "30px" }} />
                                        </div>
                                        <div style={{ display: "flex", gap: "5px" }}>
                                            <div style={{ gap: "5px" }}>
                                                {/* Sélecteur d'heure pour l'heure de départ */}
                                                <label style={{ color: "#737373" }}>Départ</label>
                                                <Select
                                                    value={formData.heureDepart}
                                                    onChange={(selectedOption) =>
                                                        setFormData({ ...formData, heureDepart: selectedOption })
                                                    }
                                                    options={hourOptions}
                                                    placeholder="Choix"
                                                    styles={{
                                                        control: (baseStyles) => ({
                                                            ...baseStyles,
                                                            height: "20px",
                                                            borderRadius: "5px",
                                                            color: "#737373"
                                                        }),
                                                        menuList: (baseStyles) => ({
                                                            ...baseStyles,
                                                            borderRadius: "5px",
                                                            color: "black"
                                                        }),
                                                    }}
                                                />
                                            </div>

                                            {/* Sélecteur d'heure pour l'heure de retour */}
                                            <div style={{ gap: "5px" }}>
                                                <label style={{ color: "#737373" }}>Fin</label>
                                                <Select
                                                    value={formData.heureRetour}
                                                    onChange={(selectedOption) =>
                                                        setFormData({ ...formData, heureRetour: selectedOption })
                                                    }
                                                    options={hourOptions}
                                                    placeholder="Choix"
                                                    styles={{
                                                        control: (baseStyles) => ({
                                                            ...baseStyles,
                                                            height: "20px",
                                                            borderRadius: "5px",
                                                            color: "#737373"
                                                        }),
                                                        menuList: (baseStyles) => ({
                                                            ...baseStyles,
                                                            borderRadius: "5px",
                                                            color: "black"
                                                        }),
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className="col-md-2" style={{ padding: isMobile ? "10px 0px 0px 0px" : "0px", alignContent: "center" }}>
                                    <Button variant="primary" style={{ borderRadius: "50px", padding: "10px 15px 10px 15px", marginTop: "10px" }} onClick={handleSearch}>Rechercher</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            <div className="container" style={{ padding: "50px 0px 50px 0px" }}>
                <div className="row">
                    {
                        !isMobile && (
                            <Col md={4}>
                                <div className="shadow-sm"
                                    style={{
                                        position: "sticky",
                                        top: "110px", // Distance depuis le haut
                                        padding: "10px 10px 50px 10px",
                                        borderRadius: "8px",
                                        backgroundColor: "#fff",

                                    }}
                                >
                                    <Row>
                                        <Col md={6}>
                                            <div className="mt-3">
                                                <div><label style={{ color: "#737373" }}>Moteur</label></div>
                                                <div className="shadow-sm" style={{ borderRadius: "30px", width: "100%", background: "#FFFFFF", padding: "10px 10px 10px 10px", display: "flex", justifyContent: "center", alignContent: "center", background: "white" }}>
                                                    <FaChargingStation color={"#D9D9D9"} size={30} style={{ padding: "" }} />
                                                    <div style={{ width: "100%" }}>
                                                        <Select options={enginetypeOptions} value={engineType} onChange={setengineType} isClearable isSearchable />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mt-3">
                                                <div><label style={{ color: "#737373" }}>Marques</label></div>
                                                <div className="shadow-sm" style={{ borderRadius: "30px", width: "100%", background: "#FFFFFF", padding: "10px 10px 10px 10px", display: "flex", justifyContent: "center", alignContent: "center", background: "white" }}>
                                                    <MdDirectionsCar color={"#D9D9D9"} size={30} style={{ padding: "" }} />
                                                    <div style={{ width: "100%" }} >
                                                        <Select options={vehiclebrandOptions} value={vehiclebrand} onChange={setvehiclebrand} isClearable isSearchable />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mt-3">
                                                <div><label style={{ color: "#737373" }}>Modèle</label></div>
                                                <div className="shadow-sm" style={{ borderRadius: "30px", width: "100%", background: "#FFFFFF", padding: "10px 10px 10px 10px", display: "flex", justifyContent: "center", alignContent: "center", background: "white" }}>
                                                    <FaCar color={"#D9D9D9"} size={30} style={{ padding: "" }} />
                                                    <div style={{ width: "100%" }}>
                                                        <Select options={vehiclemodelsOptions} value={model} onChange={setmodel} isClearable isSearchable />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mt-3">
                                                <div><label style={{ color: "#737373" }}>Catégorie</label></div>
                                                <div className="shadow-sm" style={{ borderRadius: "30px", width: "100%", background: "#FFFFFF", padding: "10px 10px 10px 10px", display: "flex", justifyContent: "center", alignContent: "center", background: "white" }}>
                                                    <MdCategory color={"#D9D9D9"} size={30} style={{ padding: "" }} />
                                                    <div style={{ width: "100%" }} >
                                                        <Select options={interiortypeOptions} value={interiorType} onChange={setinteriorType} isClearable isSearchable />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>


                                        <Col md={12}>
                                            <div className="mt-4">
                                                <div><label style={{ color: "#737373" }}>Nombre de sièges</label></div>
                                                <div
                                                    className=""
                                                    style={{
                                                        borderRadius: "30px",
                                                        width: "100%",
                                                        padding: "10px",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    {/*<MdMoney color={"#D9D9D9"} size={30} style={{ marginRight: "10px" }} /> */}
                                                    <div style={{ width: "100%" }}>
                                                        <Range
                                                            step={1}
                                                            min={1}
                                                            max={50}
                                                            values={passengerRange}
                                                            onChange={(values) => {
                                                                setPassengerRange(values);
                                                                setminPassenger(values[0]);
                                                                setmaxPassenger(values[1]);
                                                                // Vous pouvez gérer les states ici si nécessaire
                                                            }}
                                                            renderTrack={({ props, children }) => (
                                                                <div
                                                                    {...props}
                                                                    style={{
                                                                        height: '6px',
                                                                        width: '100%',
                                                                        backgroundColor: '#ddd',
                                                                        borderRadius: '3px',
                                                                        alignSelf: 'center',
                                                                    }}
                                                                >
                                                                    {children}
                                                                </div>
                                                            )}
                                                            renderThumb={({ props }) => (
                                                                <div
                                                                    {...props}
                                                                    style={{
                                                                        height: '20px',
                                                                        width: '20px',
                                                                        backgroundColor: '#D2D2D2',
                                                                        borderRadius: '50%',
                                                                        border: '2px solid #fff',
                                                                        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.15)',
                                                                        cursor: 'grab',
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-between mt-2">
                                                    <span>Min: {passengerRange[0]} Sièges</span>
                                                    <span>Max: {passengerRange[1]} Sièges</span>
                                                </div>
                                            </div>
                                        </Col>
                                        {/* Filtre par Prix */}
                                        <Col md={12}>
                                            <div className="mt-4">
                                                <div><label style={{ color: "#737373" }}>Filtrer par prix</label></div>
                                                <div
                                                    className=""
                                                    style={{
                                                        borderRadius: "30px",
                                                        width: "100%",
                                                        padding: "10px",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    {/*<MdMoney color={"#D9D9D9"} size={30} style={{ marginRight: "10px" }} /> */}
                                                    <div style={{ width: "100%" }}>
                                                        <Range
                                                            step={1}
                                                            min={1}
                                                            max={1000000}
                                                            values={priceRange}
                                                            onChange={(values) => {
                                                                setPriceRange(values);
                                                                setMinPrice(values[0]);
                                                                setMaxPrice(values[1]);
                                                                // Vous pouvez gérer les states ici si nécessaire
                                                            }}
                                                            renderTrack={({ props, children }) => (
                                                                <div
                                                                    {...props}
                                                                    style={{
                                                                        height: '6px',
                                                                        width: '100%',
                                                                        backgroundColor: '#ddd',
                                                                        borderRadius: '3px',
                                                                        alignSelf: 'center',
                                                                    }}
                                                                >
                                                                    {children}
                                                                </div>
                                                            )}
                                                            renderThumb={({ props }) => (
                                                                <div
                                                                    {...props}
                                                                    style={{
                                                                        height: '20px',
                                                                        width: '20px',
                                                                        backgroundColor: '#D2D2D2',
                                                                        borderRadius: '50%',
                                                                        border: '2px solid #fff',
                                                                        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.15)',
                                                                        cursor: 'grab',
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-between mt-2">
                                                    <span>Min: {priceRange[0]} DZD</span>
                                                    <span>Max: {priceRange[1]} DZD</span>
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Filtre par Kilométrage */}
                                        <Col md={12}>
                                            <div className="mt-4">
                                                <div><label style={{ color: "#737373" }}>Filtrer par kilométrage</label></div>
                                                <div
                                                    className=""
                                                    style={{
                                                        borderRadius: "30px",
                                                        width: "100%",
                                                        padding: "10px",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    {
                                                        /*<MdSettings color={"#D9D9D9"} size={30} style={{ marginRight: "10px" }} /> */
                                                    }
                                                    <div style={{ width: "100%" }}>
                                                        <Range
                                                            step={100}
                                                            min={1}
                                                            max={1000000}
                                                            values={mileageRange}
                                                            onChange={(values) => {
                                                                setMileageRange(values);
                                                                setminMileage(values[0]);
                                                                setmaxMileage(values[1]);
                                                                // Vous pouvez gérer les states ici si nécessaire
                                                            }}
                                                            renderTrack={({ props, children }) => (
                                                                <div
                                                                    {...props}
                                                                    style={{
                                                                        height: '6px',
                                                                        width: '100%',
                                                                        backgroundColor: '#ddd',
                                                                        borderRadius: '3px',
                                                                        alignSelf: 'center',
                                                                    }}
                                                                >
                                                                    {children}
                                                                </div>
                                                            )}
                                                            renderThumb={({ props }) => (
                                                                <div
                                                                    {...props}
                                                                    style={{
                                                                        height: '20px',
                                                                        width: '20px',
                                                                        backgroundColor: '#D2D2D2',
                                                                        borderRadius: '50%',
                                                                        border: '2px solid #fff',
                                                                        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.15)',
                                                                        cursor: 'grab',
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-between mt-2">
                                                    <span>Min: {mileageRange[0]} km</span>
                                                    <span>Max: {mileageRange[1]} km</span>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        )
                    }
                    {/* Liste des éléments (Véhicules ou Propriétés) */}
                    <Col sm={12} md={!isMobile ? 8 : 12} lg={!isMobile ? 8 : 12} xl={!isMobile ? 8 : 12} >
                        <Row>
                            <Col md={12} className="mb-3 mt-3">
                                <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                    <div></div>
                                    <div>
                                        {
                                            isMobile && (
                                                <Button type="button" variant="primary" size="sm" onClick={() => { setShowOffCanvas(true) }}> <RiFilter3Line /> Recherche personnalisée</Button>
                                            )
                                        }
                                    </div>
                                </div>
                            </Col>
                            {currentItems.length > 0 && currentItems.filter((item) => item.isVisible == true).length > 0 ? (
                                currentItems.filter((item) => item.isVisible == true).map((item) => {
                                    // État unique pour chaque élément
                                    const isHovered = hoverStates[item._id]; // Vérifie si l'élément actuel est survolé
                                    return (
                                        <Col md={6}
                                            onMouseEnter={() => handleMouseEnter(item._id)} // Déclenche lorsqu'on survole
                                            onMouseLeave={() => handleMouseLeave(item._id)} // Déclenche lorsque la souris quitte
                                        >
                                            <div className="" style={{ width: "100%" }}>
                                                <div className="shadow-sm rounded-lg" style={{ margin: "10px", width: "100%", overflow: "hidden", }}>

                                                    <div style={{
                                                        height: "200px",
                                                        background: "#F2F2F2", width: "100%",
                                                        borderBottomLeftRadius: isHovered ? "20px" : "0px",
                                                        borderBottomRightRadius: isHovered ? "20px" : "0px",
                                                    }}>
                                                        {
                                                            item && item.images && item.images.length > 0 ?
                                                                <img src={item.images[0]} style={{
                                                                    height: "200px", width: "100%",
                                                                    transition: "transform 0.3s ease-in-out",
                                                                    transform: isHovered ? "scale(1.1)" : "scale(1)", // Zoom léger sur l'image
                                                                }} />
                                                                :
                                                                <img src={emptyImage} style={{
                                                                    height: "200px", width: "100%",
                                                                    transition: "transform 0.3s ease-in-out",
                                                                    transform: isHovered ? "scale(1.1)" : "scale(1)", // Zoom léger sur l'image
                                                                }} />
                                                        }
                                                    </div>
                                                    <div style={{ background: "white", padding: "10px", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px" }}>
                                                        <div><h6 className="text-dark">{item.brand || item.name}</h6></div>
                                                        <div className="pt-2 pb-2" style={{ display: "flex", justifyContent: "space-between", }}>
                                                            <div>
                                                                <span style={{ fontWeight: "bold", fontSize: "25px" }} className="font-bold"> {item.basePricePerDay || 0} </span>
                                                                <span style={{ fontWeight: "bold", fontSize: "12px" }}>DZD</span>
                                                                <span style={{ color: "#A6A6A6", fontSize: "12px" }}>/Jour</span>
                                                            </div>
                                                            <div>
                                                                {/*<span style={{ color: "#A6A6A6", fontSize: "12px" }}> <MdLocationOn /> Algerie</span> */}
                                                            </div>
                                                        </div>
                                                        {// vehicle
                                                            item?.brand && (item?.mileage || item?.options?.automaticTransmission || item?.passenger || item?.engineType?.name) && (
                                                                <div style={{ padding: "5px 5px 5px 5px", display: "flex", justifyContent: "space-between", background: "#F6F6F6" }} className="my-3 rounded-lg">
                                                                    {// kilometrage
                                                                        item?.mileage && (
                                                                            <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                                                                <IoSpeedometerOutline className="text-dark" size={25} />
                                                                                <span className="text-dark">{item?.mileage || 0}</span>
                                                                            </div>
                                                                        )
                                                                    }
                                                                    {// transmition
                                                                        (item?.options?.automaticTransmission || item?.options?.manualTransmission) && (
                                                                            <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                                                                <TbManualGearbox className="text-dark" size={25} />
                                                                                <span className="text-dark">
                                                                                    {item?.options?.automaticTransmission ? "Auto" :
                                                                                        item?.options?.manualTransmission ? "Manuelle" : ""}
                                                                                </span>
                                                                            </div>
                                                                        )
                                                                    }
                                                                    {// Sièges
                                                                        item?.passenger && (
                                                                            <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                                                                <MdOutlineAirlineSeatReclineNormal className="text-dark" size={25} />
                                                                                <span className="text-dark">{item?.passenger || 4}</span>
                                                                            </div>
                                                                        )
                                                                    }

                                                                    {//moteur
                                                                        item?.engineType && item?.engineType?.name && (
                                                                            <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                                                                <FaChargingStation className="text-dark" size={25} />
                                                                                <span className="text-dark">{item?.engineType?.name || ""}</span>
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            )
                                                        }

                                                        {// property
                                                            item?.name && (
                                                                <div style={{ padding: "5px 5px 5px 5px", display: "flex", justifyContent: "space-between", background: "#F6F6F6" }} className="my-3 rounded-lg">

                                                                    <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "row" }}>
                                                                        <MdOutlineLocationOn className="text-dark" size={25} />
                                                                        <span className="text-dark">{item.address}</span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }

                                                        <div>
                                                            <Button type="button"
                                                                onClick={() => {
                                                                    if (item?.color) {
                                                                        dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: item });
                                                                        dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: {} });
                                                                        navigate(`/${ROUTES.CAR_DETAIL_VIEW}/${item._id}/name/${item.brand}/description/${item.brand}`);
                                                                    } else {
                                                                        dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: {} });
                                                                        dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: item });
                                                                        navigate(`/${ROUTES.CAR_DETAIL_VIEW}/${item._id}/name/${item.name}/description/${item.name}`);
                                                                    }
                                                                }}
                                                                style={{
                                                                    padding: "10px 5px 10px 5px", borderRadius: "30px", textAlign: "center", display: "flex", justifyContent: "center"
                                                                    , borderRadius: "30px",
                                                                    textAlign: "center",
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    transition: "all 0.3s ease-in-out", // Animation fluide
                                                                }}
                                                                variant={isHovered ? "dark" : "outline-dark"} // Change le variant du bouton
                                                                className={`w-100 ${isHovered ? "text-white" : "text-dark"} border-dark`}>
                                                                <div style={{ display: "flex", width: "100%", flexDirection: "row", justifyContent: isHovered ? "space-between" : "center", alignContent: "center" }}>

                                                                    <div className={`${isHovered ? "px-3 font-fold" : "p-1"}`}>
                                                                        <span className="text-center "> Voir l{"'"}offre </span>
                                                                    </div>
                                                                    {
                                                                        isHovered && (
                                                                            <div className={`${isHovered ? "px-3 font-fold" : "p-1"}`} style={{ transition: "all 0.3s ease-in-out" }}>
                                                                                <FaArrowAltCircleRight size={25} className="text-primary" />
                                                                            </div>
                                                                        )
                                                                    }

                                                                </div>
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    )
                                })
                            ) : (
                                <p className="text-center">Aucun résultat ne correspond aux critères de recherche.</p>
                            )}
                        </Row>
                        {/*onClick={() => {
                                                        if (item?.color) {
                                                            dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: item });
                                                            dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: {} });
                                                            navigate(`/${ROUTES.CAR_DETAIL_VIEW}/${item._id}/name/${item.brand}/description/${item.brand}`);
                                                        } else {
                                                            dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: {} });
                                                            dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: item });
                                                            navigate(`/${ROUTES.CAR_DETAIL_VIEW}/${item._id}/name/${item.name}/description/${item.name}`);
                                                        }
                                                    }} */}

                        {/* Pagination */}
                        <Pagination className="justify-content-center">
                            {Array.from({ length: Math.ceil((filterType === "Vehicle" ? filteredVehicles.length : filteredProperties.length) / itemsPerPage) }, (_, i) => (
                                <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => paginate(i + 1)}>
                                    {i + 1}
                                </Pagination.Item>
                            ))}
                        </Pagination>
                    </Col>
                </div>
            </div >


            {/*Loading  */}
            < Modal
                show={loadingVehicles || loadingPropertys}
                size="sm"
                centered
                style={{
                    background: "transparent",
                    border: "none",
                    boxShadow: "none",
                }}
                backdrop="static"
                keyboard={false}
                contentClassName="bg-transparent border-0 shadow-none" // Supprime le fond du modal
            >
                <Modal.Body
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "transparent", // Supprime toute couleur de fond
                        border: "none",
                        boxShadow: "none",
                        padding: "0px", // Supprime tout padding qui pourrait ajouter un fond blanc
                    }}
                >
                    <Spinner
                        animation="border"
                        variant="primary"
                        style={{
                            width: "3rem",
                            height: "3rem",
                            zIndex: 9999, // Pour s'assurer qu'il est bien au-dessus
                            filter: "drop-shadow(0px 0px 5px rgba(0,0,0,0.3))" // Ajoute un léger contour pour visibilité
                        }}
                    />
                </Modal.Body>
            </Modal >



            {/*Canvas filtre de recherche en question */}
            < Offcanvas show={showOffCanvas} onHide={() => setShowOffCanvas(false)} placement="end" >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        <RiFilter3Line /> <span> Recherche personnalisée</span>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <ContainerFilter
                        filterType={filterType}
                        setFilterType={setFilterType}
                        pickupLocation={pickupLocation}
                        handlePickupLocationChange={handlePickupLocationChange}
                        pickupSuggestions={pickupSuggestions}
                        handlePickupSelection={handlePickupSelection}
                        minPrice={minPrice}
                        setMinPrice={setMinPrice}
                        maxPrice={maxPrice}
                        setMaxPrice={setMaxPrice}
                        availableStartDate={availableStartDate}
                        setAvailableStartDate={setAvailableStartDate}
                        availableStartTime={availableStartTime}
                        setAvailableStartTime={setAvailableStartTime}
                        availableEndDate={availableEndDate}
                        setAvailableEndDate={setAvailableEndDate}
                        availableEndTime={availableEndTime}
                        setAvailableEndTime={setAvailableEndTime}
                        hourOptions={hourOptions}
                        handleSearch={handleSearch}


                        minYearBuild={minYearBuild}
                        setminYearBuild={setminYearBuild}
                        maxYearBuild={maxYearBuild}
                        setmaxYearBuild={setmaxYearBuild}
                        // nombre de passagers
                        minPassenger={minPassenger}
                        setminPassenger={setminPassenger}
                        maxPassenger={maxPassenger}
                        setmaxPassenger={setmaxPassenger}
                        // kilometrage
                        minMileage={minMileage}
                        setminMileage={setminMileage}
                        maxMileage={maxMileage}
                        setmaxMileage={setmaxMileage}
                        // Categorie
                        interiorType={interiorType}// moteur
                        setinteriorType={setinteriorType}// moteur
                        engineType={engineType}// marque
                        setengineType={setengineType}// marque
                        vehiclebrand={vehiclebrand}
                        setvehiclebrand={setvehiclebrand}
                        optionsItem={optionsItem}
                        setoptionsItem={setoptionsItem}
                        model={model}
                        setmodel={setmodel}
                    />
                </Offcanvas.Body>
            </Offcanvas >

        </div>
    );
}

export default CarUserPage;